import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Capture-first empty state for a fresh, zero-input workspace. Replaces the
 * weekly-draft machinery ("0 of N approved" / "Draft now" / "Rest day")
 * when there's nothing captured yet — the receipt has to start from a
 * capture, so that's the single primary action.
 */
export function CaptureFirstCard({
  isAr,
  onCapture,
  onLearn,
}: {
  isAr: boolean;
  onCapture: () => void;
  onLearn?: () => void;
}) {
  return (
    <section
      data-testid="capture-first-card"
      className="rounded-2xl border border-border bg-card/60 px-6 py-8 text-center flex flex-col items-center gap-3"
    >
      <span className="h-12 w-12 rounded-full bg-coral-soft/50 grid place-items-center">
        <Sparkles className="h-6 w-6 text-coral" />
      </span>
      <h2 className="font-display text-xl">
        {isAr ? "التقط أول شيء" : "Capture your first thing"}
      </h2>
      <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
        {isAr
          ? "دوّن ملاحظة، أو سجّل مذكرة صوتية، أو أضف صورة. يبدأ إيصالك مما تلتقطه."
          : "Jot a note, record a voice memo, or add a photo. Your receipt starts from what you capture."}
      </p>
      <Button
        onClick={onCapture}
        data-testid="capture-first-cta"
        className="mt-1 bg-coral hover:bg-coral/90 text-white rounded-full px-6"
      >
        {isAr ? "التقاط" : "Capture"}
      </Button>
      {onLearn ? (
        <button
          type="button"
          onClick={onLearn}
          className="text-xs text-muted-foreground hover:text-foreground"
        >
          {isAr ? "كيف تعمل الإيصالات؟" : "Learn how receipts work"}
        </button>
      ) : null}
    </section>
  );
}
